import { analyticsConstants } from '@/Constants';

const initialState = {
	wastageList: [],
	transitList: [],
	qualityList: [],
	aiQualityList: [],
	grnList: [],
	notification: {
		list: {
			leftOver: [],
			orders: [],
		},
		unreadCount: {
			leftOver: 0, orders: 0,
		},
	},
	transitLossList: [],
	singleTransitLoss: [],
	loading: false,
	faliureRequest: null,
	success: null,
};
function wastage(state = initialState, action) {
	switch (action.type) {
		case analyticsConstants.SET_WASTAGE:
			return {
				...state,
				wastageList: action.payload,
			};
		case analyticsConstants.SET_TRANSIT:
			return {
				...state,
				transitList: action.payload,
			};
		case analyticsConstants.SET_QUALITY:
			return {
				...state,
				qualityList: action.payload,
			};
		case analyticsConstants.SET_QUALITY_AI:
			return {
				...state,
				aiQualityList: action.payload,
			};
		case analyticsConstants.SET_GRN:
			return {
				...state,
				grnList: action.payload,
			};
		case analyticsConstants.SET_NOTIFICATION:
			return {
				...state,
				notification: action.payload,
			};
		case analyticsConstants.SET_TRANSIT_LOSS:
			return {
				...state,
				transitLossList: action.payload,
			};
		case analyticsConstants.SET_LOADING_REQUEST:
			return {
				...state,
				loading: action.payload,
			};
		case analyticsConstants.SET_FAILURE_REQUEST:
			return {
				...state,
				faliureRequest: action.payload,
			};
		case analyticsConstants.SET_SINGLE_TRANSIT_LOSS:
			return {
				...state,
				singleTransitLoss: action.payload,
			};
		case analyticsConstants.SET_SUCCESS:
			return {
				...state,
				success: action.payload,
			};
		default:
			return state;
	}
}
export default wastage;
